import React from 'react'
import mainPhoto from '../images/filt2.jpg'
import noise from '../images/noise.gif'

const Hero = () => {
    return (
        <div className='text-white Fixed mt-[-3.2rem]'>
            <div className='relative'>
                <img src={mainPhoto} alt="/" className='h-90 overflow:hidden' />
                <img
                    src={noise}
                    alt=""
                    aria-hidden="true"
                    className='absolute inset-0 w-full h-full object-cover opacity-[0.07] mix-blend-overlay pointer-events-none'
                />
                <div
                    className='absolute inset-x-0 top-0 h-24 pointer-events-none'
                    style={{ background: 'linear-gradient(to bottom, rgba(6,12,29,0.75) 0%, transparent 100%)' }}
                />
            </div>
        </div>
    )
}

export default Hero